const styles = theme => ({
  root: {
    alignItems: 'center',
    textAlign: 'center',
  },
  button: {
    marginTop: 24,
  },
  textF: {
    marginTop: 24,
    textAlign: 'center',
    alignItems: 'center',
  },
  textField: {
    width: '70%',
  },
  card: {
   minWidth: 250,
   maxWidth: 'calc(40%)',
   marginLeft: 'calc(50% - 125px)',
   [theme.breakpoints.up('sm')]: {
     marginLeft: 'calc(30%)',
   },
   [theme.breakpoints.up('md')]: {
     marginLeft: 'calc(30%)',
   },
 },
});


export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Summary/styles.js